import { productRecommendations } from '../data/products';
import type { Diagnosis } from '../types';

interface QuizResultProps {
  diagnosis: Diagnosis;
  userInfo: { nome: string; email: string };
}

export const QuizResult = ({ diagnosis, userInfo }: QuizResultProps) => {
  const recommendation = productRecommendations[diagnosis.grau_calvicie][diagnosis.condicao_couro] 
    || productRecommendations[diagnosis.grau_calvicie].default;

  const grauLabels = {
    inicial: 'Calvície Inicial',
    moderada: 'Calvície Moderada',
    avancada: 'Calvície Avançada',
  };

  // Links específicos para cada grau de calvície
  const treatmentLinks = {
    inicial: 'https://www.respeiteohomem.com.br/collections/shampoo-calvicie-zero?utm_source=organic&utm_campaign=&utm_medium=&utm_content=&utm_term=',
    moderada: 'https://www.respeiteohomem.com.br/collections/kit-banho-calvicie-zero?utm_source=organic&utm_campaign=&utm_medium=&utm_content=&utm_term=',
    avancada: 'https://www.respeiteohomem.com.br/collections/kit-calvicie-zero?utm_source=organic&utm_campaign=&utm_medium=&utm_content=&utm_term=',
  };

  return (
    <div className="max-w-3xl mx-auto">
      <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12">
        <div className="text-center mb-8">
          <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <i className="ri-check-line text-4xl text-green-600"></i>
          </div>
          <h1 className="text-3xl md:text-4xl font-bold text-slate-900 mb-3">
            Olá, {userInfo.nome}!
          </h1>
          <p className="text-xl text-slate-600">
            Seu diagnóstico capilar está pronto
          </p>
        </div>

        <div className="bg-red-50 rounded-xl p-6 mb-8 border-2 border-red-100">
          <h2 className="text-lg font-semibold text-slate-700 mb-4">Seu diagnóstico:</h2>
          <div className="space-y-3">
            <div className="flex items-start">
              <i className="ri-arrow-right-s-line text-[#d80005] text-xl mt-0.5 mr-2"></i>
              <div>
                <strong className="text-slate-900">Grau de calvície:</strong>
                <span className="text-slate-700 ml-2">{grauLabels[diagnosis.grau_calvicie]}</span>
              </div>
            </div>
            <div className="flex items-start">
              <i className="ri-arrow-right-s-line text-[#d80005] text-xl mt-0.5 mr-2"></i>
              <div>
                <strong className="text-slate-900">Condição do couro cabeludo:</strong>
                <span className="text-slate-700 ml-2 capitalize">{diagnosis.condicao_couro}</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t-2 border-slate-100 pt-8 mb-8">
          <h2 className="text-2xl font-bold text-slate-900 mb-4">
            Tratamento recomendado
          </h2>
          <div className="bg-gradient-to-br from-black to-[#1a1a1a] rounded-xl p-6 text-white mb-4">
            <h3 className="text-2xl font-bold mb-2">{recommendation.produto}</h3>
            <p className="text-gray-200 text-lg leading-relaxed">
              {recommendation.descricao}
            </p>
          </div>
          {diagnosis.grau_calvicie !== 'inicial' && (
            <div className="bg-amber-50 border-2 border-amber-200 rounded-xl p-5">
              <div className="flex items-start">
                <i className="ri-information-line text-amber-600 text-xl mr-3 mt-0.5"></i>
                <p className="text-amber-900 text-base">
                  <strong>Atenção:</strong> Para casos de calvície {diagnosis.grau_calvicie}, 
                  recomendamos um tratamento completo que será apresentado a seguir.
                </p>
              </div>
            </div>
          )}
        </div>

        <div className="space-y-4">
          <button
            onClick={() => window.location.href = treatmentLinks[diagnosis.grau_calvicie]}
            className="w-full px-8 py-5 bg-[#d80005] text-white rounded-xl font-bold text-lg hover:bg-[#b00004] transition-all shadow-lg hover:shadow-xl whitespace-nowrap"
          >
            Ver tratamento indicado
          </button>
          <button
            onClick={() => window.location.reload()}
            className="w-full px-8 py-4 border-2 border-slate-300 text-slate-700 rounded-xl font-semibold hover:bg-slate-50 transition-colors whitespace-nowrap"
          >
            Fazer novo diagnóstico
          </button>
        </div>
      </div>

      <div className="text-center mt-8">
        <p className="text-slate-600 text-sm">
          Enviamos uma cópia do seu diagnóstico para <strong>{userInfo.email}</strong>
        </p>
      </div>
    </div>
  );
};
